@if (user?.aiBalance) {
    <div
        class="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-primary-50 px-2 py-1 dark:bg-primary-900 sm:gap-1.5 sm:px-3"
        [appPopover]="planPopover"
    >
        <mat-icon
            class="icon-size-4 text-primary"
            [svgIcon]="'heroicons_solid:sparkles'"
        ></mat-icon>
        <span class="text-sm font-semibold tabular-nums">{{
            user.aiBalance.balanceCredits | number | removeComma
        }}</span>
    </div>

    <ng-template #planPopover>
        <div class="bg-card min-w-56 rounded-lg border p-3 shadow-lg dark:border-gray-700">
            <div class="mb-2 flex items-center gap-2 border-b pb-2 dark:border-gray-700">
                <mat-icon
                    class="icon-size-4 text-primary"
                    [svgIcon]="'heroicons_solid:sparkles'"
                ></mat-icon>
                <span class="text-sm font-medium">{{
                    'components.credits.credit_balance' | transloco
                }}</span>
            </div>
            <div class="space-y-1.5 text-sm">
                @if (user.plan?.plan) {
                    <div class="flex items-center justify-between gap-4">
                        <span class="text-secondary">{{
                            'components.credits.plan' | transloco
                        }}</span>
                        <span class="font-medium">{{
                            'components.credits.plans.' + user.plan.plan | transloco
                        }}</span>
                    </div>
                }
                @if (user.plan?.expireDate) {
                    <div class="flex items-center justify-between gap-4">
                        <span class="text-secondary">{{
                            'components.credits.expire_date' | transloco
                        }}</span>
                        <span class="flex items-center gap-2">
                            <span class="font-medium">{{
                                user.plan.expireDate | date: 'dd.MM.yyyy'
                            }}</span>
                            @if (!user.employee) {
                                <a
                                    class="font-medium text-primary hover:underline"
                                    [routerLink]="'/settings/general/finance'"
                                    >{{ 'components.credits.renew' | transloco }}</a
                                >
                            }
                        </span>
                    </div>
                }
                <div class="flex items-center justify-between gap-4">
                    <span class="text-secondary">{{
                        'components.credits.monthly_allowance' | transloco
                    }}</span>
                    <span class="font-medium">{{
                        user.aiBalance.monthlyAllowanceCredits | number | removeComma
                    }}</span>
                </div>
            </div>
            <a
                class="mt-2 block border-t pt-2 text-sm font-medium text-primary hover:underline dark:border-gray-700"
                [routerLink]="'/settings/credits'"
                >{{ 'components.credits.buy_credits' | transloco }}</a
            >
        </div>
    </ng-template>
}
